/**
 * @generated SignedSource<<4ff4f9da78fdaa144bdebfb232533869>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingKindEnum = "agm" | "commitee" | "other" | "%future added value";
export type MeetingUpdateInput = {
  clientMutationId?: string | null | undefined;
  meeting: MeetingUpdateInputObject;
};
export type MeetingUpdateInputObject = {
  date?: any | null | undefined;
  description?: string | null | undefined;
  id: string;
  kind?: MeetingKindEnum | null | undefined;
  link?: string | null | undefined;
  locked?: boolean | null | undefined;
  name?: string | null | undefined;
};
export type DescriptionFormMeetings_Mutation$variables = {
  input: MeetingUpdateInput;
};
export type DescriptionFormMeetings_Mutation$data = {
  readonly updateMeeting: {
    readonly meeting: {
      readonly assignees: {
        readonly " $fragmentSpreads": FragmentRefs<"Assignment_Assignees" | "Avatars_users">;
      } | null | undefined;
      readonly date: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly link: string | null | undefined;
      readonly locked: boolean | null | undefined;
      readonly name: string | null | undefined;
      readonly tasks: {
        readonly __id: string;
        readonly totalCount: number;
        readonly " $fragmentSpreads": FragmentRefs<"Checklist_TaskConnection">;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"CommentFeed_comments">;
    };
  };
};
export type DescriptionFormMeetings_Mutation = {
  response: DescriptionFormMeetings_Mutation$data;
  variables: DescriptionFormMeetings_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "key": "date",
        "value": "asc"
      }
    ]
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v10 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v10/*: any*/)
],
v14 = [
  (v3/*: any*/)
],
v15 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "key": "createdAt",
        "value": "desc"
      }
    ]
  }
],
v16 = [
  (v9/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "LikeConnection",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DescriptionFormMeetings_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MeetingUpdatePayload",
        "kind": "LinkedField",
        "name": "updateMeeting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Meeting",
            "kind": "LinkedField",
            "name": "meeting",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "assignees",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Avatars_users"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Assignment_Assignees"
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CommentFeed_comments"
                  }
                ],
                "type": "CommentableInterface",
                "abstractKey": "__isCommentableInterface"
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "TaskConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Checklist_TaskConnection"
                  },
                  (v10/*: any*/)
                ],
                "storageKey": "tasks(order:[{\"key\":\"date\",\"value\":\"asc\"}])"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DescriptionFormMeetings_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MeetingUpdatePayload",
        "kind": "LinkedField",
        "name": "updateMeeting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Meeting",
            "kind": "LinkedField",
            "name": "meeting",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "assignees",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "TaskConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": "users",
                            "args": null,
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "assignees",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dueDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "complete",
                            "storageKey": null
                          },
                          {
                            "alias": "title",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "parent",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "type": "TaskableInterface",
                                "abstractKey": "__isTaskableInterface"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "Club",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "Meeting",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "Position",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v14/*: any*/),
                                "type": "Project",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v15/*: any*/),
                            "concreteType": "CommentConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": "comments(order:[{\"key\":\"createdAt\",\"value\":\"desc\"}])"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": "tasks(order:[{\"key\":\"date\",\"value\":\"asc\"}])"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v15/*: any*/),
                    "concreteType": "CommentConnection",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": (v15/*: any*/),
                                "concreteType": "CommentConnection",
                                "kind": "LinkedField",
                                "name": "comments",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v20/*: any*/),
                                          (v3/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": "comments(order:[{\"key\":\"createdAt\",\"value\":\"desc\"}])"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": "comments(order:[{\"key\":\"createdAt\",\"value\":\"desc\"}])"
                  }
                ],
                "type": "CommentableInterface",
                "abstractKey": "__isCommentableInterface"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3702a0d190ab775fb00a4b90e8501368",
    "id": null,
    "metadata": {},
    "name": "DescriptionFormMeetings_Mutation",
    "operationKind": "mutation",
    "text": "mutation DescriptionFormMeetings_Mutation(\n  $input: MeetingUpdateInput!\n) {\n  updateMeeting(input: $input) {\n    meeting {\n      date\n      assignees {\n        ...Avatars_users\n        ...Assignment_Assignees\n      }\n      id\n      name\n      link\n      description\n      locked\n      ... on CommentableInterface {\n        __isCommentableInterface: __typename\n        ...CommentFeed_comments\n      }\n      tasks(order: [{key: date, value: asc}]) {\n        totalCount\n        ...Checklist_TaskConnection\n      }\n    }\n  }\n}\n\nfragment Assignment_Assignees on UserConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n\nfragment Avatar_user on User {\n  id\n  name\n  email\n  imageUrl\n}\n\nfragment Avatars_users on UserConnection {\n  ...Assignment_Assignees\n  edges {\n    node {\n      id\n      ...Avatar_user\n    }\n  }\n}\n\nfragment Checklist_TaskConnection on TaskConnection {\n  edges {\n    node {\n      id\n      users: assignees {\n        edges {\n          node {\n            id\n          }\n        }\n        ...Avatars_users\n        ...Assignment_Assignees\n      }\n      dueDate\n      complete\n      title: description\n      parent {\n        __typename\n        ... on TaskableInterface {\n          __isTaskableInterface: __typename\n          id\n          name\n          __typename\n        }\n        ... on Club {\n          id\n        }\n        ... on Meeting {\n          id\n        }\n        ... on Position {\n          id\n        }\n        ... on Project {\n          id\n        }\n      }\n      comments(order: [{key: createdAt, value: desc}]) {\n        totalCount\n      }\n    }\n  }\n}\n\nfragment CommentFeed_comments on CommentableInterface {\n  __isCommentableInterface: __typename\n  comments(order: [{key: createdAt, value: desc}]) {\n    totalCount\n    edges {\n      node {\n        id\n        content\n        author {\n          name\n          ...Avatar_user\n          id\n        }\n        likes {\n          totalCount\n        }\n        createdAt\n        comments(order: [{key: createdAt, value: desc}]) {\n          edges {\n            node {\n              createdAt\n              id\n              content\n              author {\n                name\n                ...Avatar_user\n                id\n              }\n              likes {\n                totalCount\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "049baa492e42bec283474ec5c2006e5d";

export default node;
